import React, { useState } from 'react';
import { useParams, Link, useOutletContext } from 'react-router-dom';

import { collection, query, doc, orderBy, where} from "firebase/firestore";
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';

import { db } from './firebase'
import { useHuntPlayers } from './members';

import UploadItem from './play/UploadItem';
import SummaryTable from './play/SummaryTable';
import SubmissionDetails from './play/SubmissionDetails';


export default function Play() {
    let { huntId } = useParams();
    const { uid } = useOutletContext();

    // State from firebase
    const huntRef = doc(db, "hunts", huntId);

    const itemsRef = collection(db, "hunts", huntId, "items");
    const itemsQuery = query(itemsRef, orderBy("author"));

    const submsRef = collection(db, "hunts", huntId, "submissions");
    const submsQuery = query(submsRef, where("active", "==", true));

    const [hunt, huntLoading, huntError] = useDocument(huntRef);
    const memberIds = hunt?.data()?.memberIds;
    const [players, playersLoading, playersError] = useHuntPlayers(memberIds);
    const [items, itemsLoading, itemsError] = useCollection(itemsQuery);
    const [subms, submsLoading, submsError] = useCollection(submsQuery);

    const [curSubDetails, setCurSubDetails] = useState(null);

    // Allow for editing of hunt after hunt is over
    const [editOverride, setEditOverride] = useState(false);

    // Probably a better way to do this lol
    if (huntLoading || playersLoading || itemsLoading || submsLoading) {
        return <p>Loading</p>
    }

    if (huntError || playersError || itemsError || submsError) {
        return <p>Error!</p>
    }

    // Gate access to members. Unmigrated hunts have no memberIds and will
    // fail subcollection reads under the deployed rules, so treat them the
    // same as not-a-member.
    if (!Array.isArray(memberIds) || !memberIds.includes(uid)) {
        return <p>You're not a member of this hunt. <Link to={"/join/" + huntId}>Join it</Link> to play.</p>
    }

    const startDate = new Date(hunt.data().startDate.seconds * 1000);
    const endDate = new Date(hunt.data().endDate.seconds * 1000);
    const now = Date.now();

    return (
    <div>
        <h1 style={{
            marginBottom: "5px"
        }}>
            {hunt.data().displayName}
        </h1>

        <div style={{
            marginBottom: "0.67em"

        }}>
            <Link to={"/gallery/" + huntId}>View Gallery</Link>
        </div>

        <div>

            {/* { now  < startDate && !editOverride
                ? (
                    <p>The hunt has not started yet! Click <a href="#" onClick={() => setEditOverride(true)}>here</a> to upload items anyways!</p>
                )
                : (
                    now > endDate && ! editOverride
                        ? <p>The hunt is now finished! Click <a href="#" onClick={() => setEditOverride(true)}>here</a> to upload items anyways! </p>
                        : <UploadItem huntId={huntId} items={items}></UploadItem>
                )
            } */}

            <UploadItem huntId={huntId} items={items}></UploadItem>

            <br />
            <hr />
            <br />

            <SummaryTable items={items} subms={subms} players={players} setCurSubDetails={setCurSubDetails}></SummaryTable>

            { curSubDetails && <>
                <br />
                <hr />
                <br />
                <SubmissionDetails submission={curSubDetails}></SubmissionDetails>

            </>}
        </div>

    </div>
    );
}
